import { Component, Input, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { Guest } from '@app/core/models/guest.model';
import { Subscription } from 'rxjs';
import { GuestReferences } from '@app/core/models/guest-references.model';
import { DataService } from '../core/services/data/data.service';
import * as _ from 'lodash';
import { ModalService } from '@app/shared/services/modal';
import * as UI_CONSTANTS from '@app/hotel-account-pin/hotel-account-pin.constants';
import { ReservationService } from '@core/services/reservation.service';
import { aulani_campus, commonId } from 'app/core/constants/common-constants';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';


@Component({
    selector: 'dtr-hub-hotel-account-pin',
    templateUrl: './hotel-account-pin.component.html',
    styleUrls: ['./hotel-account-pin.component.scss']
})
export class HotelAccountPinComponent implements OnInit, OnDestroy {

    @Input() campus;
    @Input() collapsed;
    @Input() isAddFlow;
    @Input() saveInProgress;
    @Input() dscbDetails;
    private _guests: Guest[];
    private _guestReferences: GuestReferences[];
    avatarSub: Subscription;
    pinErrorMsg: string[];
    showPINError = false;

    _pinAvailable: boolean;
    guestForPINCount: number;
    showModal = false;
    primaryGuest: boolean;
    pinMissing: boolean;
    guestsForDisplay: any = [];
    isDisabled = false;
    checkBoxSelected =  false;
    showEditButton = this.reservationService.isHAPSaveSet();
    UI_CONSTANTS;

    errorResponse: any;
    error: any;
    hotelAccPInData: any;
    pinModalData: any;
    commonData: any;
    aboutOcliData: any;
    hotelAccPinForm: FormGroup;
    pinError: any;
    confirmPinError: any;

    @ViewChild('pinModal') pinModal: ElementRef;

    @Input() set guests(value) {
        this._guests = value;
    }

    @Input() set guestReferences(value) {
        const guestReferences = [];
        _.forEach(value, function (accommodationDetail) {
            _.forEach(accommodationDetail.guestReferences, function (guestReference) {
                guestReferences.push(guestReference);
            });
        });
        this._guestReferences = guestReferences;
    }

    constructor(public dataService: DataService,
        public modalService: ModalService,
        private renderer: Renderer2,
        private fb: FormBuilder,
        public reservationService: ReservationService) { }

    ngOnInit() {
        this.UI_CONSTANTS = UI_CONSTANTS;
        this.hotelAccPInData = _.find(this.dscbDetails, function(module) {
            return module.id === UI_CONSTANTS.moduleId;
        });
        this.pinModalData = _.find(this.dscbDetails, function(module) {
            return module.id === UI_CONSTANTS.addpinID;
        });
        this.commonData = _.find(this.dscbDetails, function(module) {
            return module.id === commonId;
        });
        this.aboutOcliData = _.find(this.dscbDetails, function(module) {
            return module.id === UI_CONSTANTS.infoModuleId;
        });
        this.setPinErrorObj();
        this.setupGuestDetails();
    }

    setupGuestDetails() {
        const guestsForPIN: Guest[] = _.filter(this._guestReferences, function (guest) {
            return 2 < guest.age;
        });
        const guestWithoutPIN: Guest[] = _.filter(this._guests, function (guest) {
            const findGuestForPIN: Guest[] = _.filter(guestsForPIN, function (guestForPin) {
                return guestForPin.guest.guestIdReferences.value === guest.externalReference.referenceValue;
            });
            return guest.pinAvailable === false && findGuestForPIN.length > 0;
        });

        this.guestForPINCount = guestsForPIN.length;
        this._pinAvailable = guestWithoutPIN.length <= 0 && this._guests && this._guests.length > 0;
        if (this.pinAvailable) {
            this.reservationService.setHAPSaveSet(true);
            this.reservationService.roomcheckinPayload.chargeAccountDetails = null;
        } else {
            const allPinsValid: boolean = this.isPinsSetFromCache(this.reservationService.roomcheckinPayload.chargeAccountDetails);
            if (allPinsValid) {
                this.reservationService.setHAPSaveSet(true);
            } else {
                this.reservationService.setHAPSaveSet(false);
            }
            this.showPINError = true;
            this.pinErrorMsg = [this.hotelAccPInData.sections.pinNotSet];
        }

        const tempGuestList: any = [];
        const tempChargeAccountGuestList = this._guests;

        _.forEach(guestsForPIN, function (guestInfo) {

            const guestDetail = {
                primaryGuest: guestInfo.guest.primaryGuest,
                partyId: guestInfo.guest.partyId,
                guestId: guestInfo.guest.guestId,
                avatarId: guestInfo.guest.avatarId,
                avatarUrl: guestInfo.guest.avatarUrl,
                firstName: guestInfo.guest.firstName,
                lastName: guestInfo.guest.lastName,
                pinAvailable: false,
                guestIdReferences: {
                    type: guestInfo.guest.guestIdReferences.type,
                    value: guestInfo.guest.guestIdReferences.value
                },
                showError: false,
                showEnterPINError: false,
                showEnterConfirmPINError: false,
                showPINNonNumericError: false,
                showPINSeqError: false,
                showPINDiffError: false,
                enterPINValid: true,
                enterConfirmPINValid: true,
                isPINSeq: false,
                isConfirmPINSeq: false,
                isPINNonNumeric: false,
                isConfirmPINNonNumeric: false
            };
            if (guestInfo.guest.primaryGuest === true) {
                tempGuestList.unshift(guestDetail);
            } else {
                tempGuestList.push(guestDetail);
            }
        });

        this.guestsForDisplay = tempGuestList;

        _.forEach(this.guestsForDisplay, function (guest) {
            const chargeAccountDetails = _.filter(tempChargeAccountGuestList, function (chargeAcccountGuest) {
                return guest.guestIdReferences.value === chargeAcccountGuest.externalReference.referenceValue;
            })[0];
            if (chargeAccountDetails) {
                guest.firstName = chargeAccountDetails.firstName;
                guest.lastName = chargeAccountDetails.lastName;
                guest.chargeAccountId = chargeAccountDetails.chargeAccountId;
                guest.pinAvailable = chargeAccountDetails.pinAvailable;
                guest.externalReference = {
                    referenceName: chargeAccountDetails.externalReference.referenceName,
                    referenceValue: chargeAccountDetails.externalReference.referenceValue
                };
                if (!chargeAccountDetails.pinAvailable) {
                    guest.pinNumber = '';
                    guest.confirmPinNumber = '';
                }
            }
        });

        this.hotelAccPinForm = this.fb.group({
            guestArray: this.fb.array(this.guestsForDisplay.map((guest, index) => this.createPinGroup(guest, index)))
        });

        this.pinMissing = _.filter(this.guestsForDisplay, function (guest) {
            return !guest.primaryGuest && !guest.pinAvailable;
        }).length > 0;
    }

    createPinGroup(guest: any, index: number): FormGroup  {
        return this.fb.group({
            pinControl: ['', Validators.compose([Validators.required, this.customPinValidator(index)])],
            confirmPinControl: ['', Validators.compose([Validators.required, this.customPinValidator(index)])]
        });
    }

    get guestArray(): FormArray {
        return this.hotelAccPinForm.get('guestArray') as FormArray;
    }

    isPinsSetFromCache(chargeAccountDetails): boolean {
        if (!chargeAccountDetails || !chargeAccountDetails.guests || chargeAccountDetails.guests.length === 0) {
            return false; // Empty object or no guests
        }
        return chargeAccountDetails.guests.every((guest) => guest.pinNumber !== null && guest.pinNumber !== '');
    }

    get pinAvailable(): boolean {
        return this._pinAvailable;
    }

    get hotelAccontPINHeading(): string {
        return this.hotelAccPInData.sections.title;
    }

    get hotelAccontPINHeadingLabel(): string {
        return this.hotelAccPInData.sections.title;
    }

    get hotelAccontPINUnavailable(): string {
        return this.hotelAccPInData.sections.body;
    }

    get hotelAccontPINAvailableText(): string {
        return this.hotelAccPInData.sections.footerEdit;
    }

    get hotelAccontPinsSet(): string {
        return `${this.hotelAccPInData.sections.bodyEdit1} ${this.guestForPINCount} ` +
            `${this.hotelAccPInData.sections.bodyEdit2} ${this.guestForPINCount}`;
    }

    get hotelAccontPINAdd(): string {
        return this.commonData.descriptions[0].sections.addLabel;
    }

    get hotelAccontPINAddText(): string {
        return this.commonData.descriptions[0].sections.addLabel;
    }

    get hotelAccontPINEdit(): string {
        return this.commonData.descriptions[0].sections.editLabel;
    }

    get hotelAccontPINEditText(): string {
        return this.commonData.descriptions[0].sections.editLabel;
    }

    get enterConfirmPINError(): string {
        return this.pinModalData.descriptions[0].sections.confirmPINError;
    }

    get enterPINError(): string {
        return this.pinModalData.descriptions[0].sections.pinError;
    }

    get nonNumericPINError(): string {
        return this.pinModalData.descriptions[0].sections.pinInvalid;
    }

    get pinSeqError(): string {
        return this.pinModalData.descriptions[0].sections.consecutiveNumber;
    }

    get mismatchPINError(): string {
        return this.pinModalData.descriptions[0].sections.pinMissmatch;
    }

    get getRequiredField() {
        return this.aboutOcliData.sections.footer;
    }

    setPinErrorObj() {
        this.pinError = {
            required: this.pinModalData.descriptions[0].sections.pinError,
            doesNotMeetCriteria: this.pinModalData.descriptions[0].sections.confirmPinCriteriaError
        };
        this.confirmPinError = {
            required: this.pinModalData.descriptions[0].sections.confirmPINError,
            doesNotMeetCriteria: this.pinModalData.descriptions[0].sections.confirmPinCriteriaError
        };
    }

    pinValueChange(value: any, index: number) {
        this.guestArray?.at(index).get('pinControl').patchValue(value);
        this.guestsForDisplay[index].pinNumber = value;
        this.guestsForDisplay[index].validatePIN = true;
        this.isGuestPINValid(this.guestsForDisplay[index], false);
        const confirmPinCtrl = this.guestArray?.at(index).get('confirmPinControl');
        if (confirmPinCtrl.value) { confirmPinCtrl.updateValueAndValidity(); }// Run confirm pin validators
    }

    confirmPinValueChange(value: any, index: number) {
        this.guestArray?.at(index).get('confirmPinControl').patchValue(value);
        this.guestsForDisplay[index].confirmPinNumber = value;
        this.guestsForDisplay[index].validateConfirmPIN = true;
        this.isGuestConfirmPINValid(this.guestsForDisplay[index], false);
        const pinCtrl = this.guestArray?.at(index).get('pinControl');
        if (pinCtrl.value) { pinCtrl.updateValueAndValidity(); } // Run pin validators
    }

    pinKeyup(event: any, index: number) {
        if (event && event.target && event.target.value && event.target.value.length === 4) {
            this.pinValueChange(event.target.value, index);
            this.guestArray?.at(index).get('pinControl').updateValueAndValidity();
        }
    }

    confirmPinKeyup(event: any, index: number) {
        if (event && event.target && event.target.value && event.target.value.length === 4) {
            this.confirmPinValueChange(event.target.value, index);
            this.guestArray?.at(index).get('confirmPinControl').updateValueAndValidity();
        }
    }

    openModal() {
        this.setupGuestDetails();
        this.modalService.open('pin-modal');
    }

    showPinErrorMsg(index: number) {
        return !this.guestsForDisplay[index].pinAvailable && this.guestsForDisplay[index].showError &&
            (this.guestsForDisplay[index].showPINNonNumericError ||
            this.guestsForDisplay[index].showPINSeqError ||
            this.guestsForDisplay[index].showPINDiffError);
    }

    customPinValidator(index: any): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            const value = control.value;
            if (value) {
                const isPINNonNumeric = value.length > 0 ? !this.checkNumericPIN(value) : false;
                const isPINNonSeq = value.length === 4 ? !this.checkSeqPIN(value) : false;
                const isPINMismatch = !this.checkPinMatch(index);
                if (isPINNonNumeric || isPINNonSeq || isPINMismatch) {
                    return { 'doesNotMeetCriteria': true };
                }
            }

            return null;
        };
    }

    pinsMatchMsg(index: number) {
        let msg = '';
        const pin = this.guestArray?.at(index).get('pinControl').value;
        const confirmPin = this.guestArray?.at(index).get('confirmPinControl').value;
        if (pin && confirmPin && pin === confirmPin && pin.length === 4 && !this.showPinErrorMsg(index)) {
            msg = this.pinModalData.descriptions[1].sections.pinMatch;
        }

        return msg;
    }

    checkPinMatch(index: number) {
        const pin = this.guestArray?.at(index).get('pinControl').value;
        const confirmPin = this.guestArray?.at(index).get('confirmPinControl').value;
        if (pin && confirmPin) {
            return pin === confirmPin;
        }

        return true;
    }
 
    closeModal() {
        this.modalService.close('pin-modal');
        this.isDisabled = false;
        _.forEach(this.guestsForDisplay, function (guest) {
            guest.showError = false;
            guest.showEnterPINError = false;
            guest.showEnterConfirmPINError = false;
            guest.showPINNonNumericError = false;
            guest.showPINSeqError = false;
            guest.showPINDiffError = false;
            guest.enterPINValid = true;
            guest.enterConfirmPINValid = true;
            guest.isPINSeq = false;
            guest.isConfirmPINSeq = false;
            guest.isPINNonNumeric = false;
            guest.isConfirmPINNonNumeric = false;
        });
        this.resetForm();
    }

    resetForm() {
        this.guestArray.controls.forEach((formItem, index: number) => {
            formItem.get('pinControl').patchValue('');
            formItem.get('pinControl').reset();
            formItem.get('pinControl').setErrors(null);
            formItem.get('pinControl').markAsPristine();
            formItem.get('pinControl').updateValueAndValidity();

            formItem.get('confirmPinControl').patchValue('');
            formItem.get('confirmPinControl').reset();
            formItem.get('confirmPinControl').setErrors(null);
            formItem.get('confirmPinControl').markAsPristine();
            formItem.get('confirmPinControl').updateValueAndValidity();
            this.guestArray.at(index).updateValueAndValidity();
        });
        this.hotelAccPinForm.markAsPristine();
        this.hotelAccPinForm.updateValueAndValidity();
    }

    updatePinNumber() {
        let invalidPINExist = false;
        let index = 0;
        const that = this;
        this.guestsForDisplay.forEach((item, index) => {
            this.guestArray?.at(index).get('pinControl').markAsDirty();
            this.guestArray?.at(index).get('confirmPinControl').markAsDirty();
            this.guestArray?.at(index).get('pinControl').updateValueAndValidity();
            this.guestArray?.at(index).get('confirmPinControl').updateValueAndValidity();
        });

        _.forEach(this.guestsForDisplay, function validateGuestDetails(guestDetail) {
            if (guestDetail.pinAvailable) {
                index++;
                return;
            }
            guestDetail.validatePIN = true;
            guestDetail.validateConfirmPIN = true;
            if (that.isDisabled && index > 0) {
                guestDetail.pinNumber = that.guestsForDisplay[0].pinNumber;
                guestDetail.confirmPinNumber = that.guestsForDisplay[0].confirmPinNumber;
                guestDetail.showError = false;
                guestDetail.showEnterPINError = false;
                guestDetail.showEnterConfirmPINError = false;
                guestDetail.showPINNonNumericError = false;
                guestDetail.showPINSeqError = false;
                guestDetail.showPINDiffError = false;
                guestDetail.enterPINValid = true;
                guestDetail.enterConfirmPINValid = true;
                guestDetail.isPINSeq = false;
                guestDetail.isConfirmPINSeq = false;
                guestDetail.isPINNonNumeric = false;
                guestDetail.isConfirmPINNonNumeric = false;

                return;
            }
            const pinErrorExist = !that.isGuestPINValid(guestDetail, false);
            const confirmPINErrorExist = !that.isGuestConfirmPINValid(guestDetail, false);

            invalidPINExist = invalidPINExist === true ? invalidPINExist : (pinErrorExist || confirmPINErrorExist);
            index++;
        });

        if (invalidPINExist) {
            return;
        }

        const guestPinList = [];
        _.forEach(this.guestsForDisplay, function (guest) {
            if (!guest.pinAvailable) {
                const guestObj = {
                    'firstName': guest.firstName,
                    'lastName': guest.lastName,
                    'externalReference': {
                        'referenceName': guest.guestIdReferences.type,
                        'referenceValue': guest.guestIdReferences.value
                    },
                    'pinNumber': guest.pinNumber
                };
                guestPinList.push(guestObj);
            }
        });
        this.reservationService.roomcheckinPayload.chargeAccountDetails = {
            'guests': guestPinList
        };
        this.reservationService.setHAPSaveSet(true);
        this.showPINError = false;
        this.showEditButton = true;
        this.showModal = false;
        this.isDisabled = false;
        this.modalService.close('pin-modal');
        this.resetForm();
    }

    onCheckBoxChanged(e) {
        const that = this;
        this.isDisabled = e.detail.value;
        this.checkBoxSelected = this.isDisabled;
        let index = 0;
        _.forEach(this.guestsForDisplay, function validateGuestDetails(guestDetail) {
            guestDetail.pinNumber = that.guestsForDisplay[0].pinNumber;
            guestDetail.confirmPinNumber = that.guestsForDisplay[0].confirmPinNumber;

            if (index > 0 && that.checkBoxSelected === true) {
                guestDetail.showError = false;
                guestDetail.showEnterPINError = false;
                guestDetail.showEnterConfirmPINError = false;
                guestDetail.showPINNonNumericError = false;
                guestDetail.showPINSeqError = false;
                guestDetail.showPINDiffError = false;
                guestDetail.enterPINValid = true;
                guestDetail.enterConfirmPINValid = true;
                guestDetail.isPINSeq = false;
                guestDetail.isConfirmPINSeq = false;
                guestDetail.isPINNonNumeric = false;
                guestDetail.isConfirmPINNonNumeric = false;

                if (that.guestArray) {
                    that.guestArray?.at(index).get('pinControl').patchValue(that.guestsForDisplay[0].pinNumber);
                    that.guestArray?.at(index).get('confirmPinControl').patchValue(that.guestsForDisplay[0].confirmPinNumber);
                    that.guestArray?.at(index).get('pinControl').updateValueAndValidity();
                    that.guestArray?.at(index).get('confirmPinControl').updateValueAndValidity();
                }
            }
            index++;
        });
    }

    get pinForEveryoneText(): string {
        const isChecked = this.isDisabled ? this.pinModalData.descriptions[1].sections.checkboxAccessibilityChecked : this.pinModalData
                            .descriptions[1].sections.checkboxAccessibilityUnChecked;
        return isChecked + ' ' + this.pinModalData.descriptions[1].sections.checkeMessage + ', checkbox';
    }

    ngOnDestroy(): void {
        if (this.avatarSub) {
            this.avatarSub.unsubscribe();
        }
    }

    isGuestPINValid(guestDetail, skipValidation) {
        if (skipValidation) {
            return true;
        }
        let isPINEmpty = false;
        let isPINNonNumeric = false;
        let isPINNonSeq = false;
        let isPINMismatch = false;

        isPINEmpty = this.checkEmptyPIN(guestDetail.pinNumber);
        isPINNonNumeric = guestDetail.pinNumber.length > 0 ? !this.checkNumericPIN(guestDetail.pinNumber) : false;
        isPINNonSeq = guestDetail.pinNumber.length === 4 ? !this.checkSeqPIN(guestDetail.pinNumber) : false;
        isPINMismatch = guestDetail.validatePIN && guestDetail.validateConfirmPIN ? this.checkPINMismatch(guestDetail) : false;

        guestDetail.showEnterPINError = isPINEmpty;
        guestDetail.enterPINValid = !isPINEmpty && !isPINNonNumeric && !isPINMismatch && !isPINNonSeq;
       
        guestDetail.isPINNonNumeric = isPINNonNumeric;
        guestDetail.showPINNonNumericError = guestDetail.isPINNonNumeric || guestDetail.isConfirmPINNonNumeric;
        guestDetail.showPINDiffError = isPINMismatch;
        guestDetail.isPINSeq = isPINNonSeq;
        guestDetail.showPINSeqError = guestDetail.isPINSeq || guestDetail.isConfirmPINSeq;
        guestDetail.enterConfirmPINValid = !guestDetail.showEnterConfirmPINError && !guestDetail.isConfirmPINNonNumeric &&
            !guestDetail.isConfirmPINSeq && !isPINMismatch;

        guestDetail.showError = !guestDetail.enterPINValid || !guestDetail.enterConfirmPINValid;

        return !guestDetail.showError;
    }

    isGuestConfirmPINValid(guestDetail, skipValidation) {
        if (skipValidation) {
            return true;
        }
        let isConfirmPINEmpty = false;
        let isConfirmPINNonNumeric = false;
        let isConfirmPINNonSeq = false;
        let isPINMismatch = false;

        isConfirmPINEmpty = this.checkEmptyPIN(guestDetail.confirmPinNumber);
        isConfirmPINNonNumeric = guestDetail.confirmPinNumber.length > 0 ? !this.checkNumericPIN(guestDetail.confirmPinNumber) : false;
        isConfirmPINNonSeq = guestDetail.confirmPinNumber.length === 4 ? !this.checkSeqPIN(guestDetail.confirmPinNumber) : false;
        isPINMismatch = guestDetail.validatePIN && guestDetail.validateConfirmPIN ? this.checkPINMismatch(guestDetail) : false;

        guestDetail.showEnterConfirmPINError = isConfirmPINEmpty;
        guestDetail.enterConfirmPINValid = !isConfirmPINEmpty && !isConfirmPINNonNumeric && !isConfirmPINNonSeq && !isPINMismatch;
        guestDetail.isConfirmPINNonNumeric = isConfirmPINNonNumeric;
        guestDetail.showPINNonNumericError = guestDetail.isPINNonNumeric || guestDetail.isConfirmPINNonNumeric;
        guestDetail.showPINDiffError = isPINMismatch;
        guestDetail.isConfirmPINSeq = isConfirmPINNonSeq;
        guestDetail.showPINSeqError = guestDetail.isPINSeq || guestDetail.isConfirmPINSeq;
        guestDetail.enterPINValid = !guestDetail.showEnterPINError && !guestDetail.isPINNonNumeric &&
            !guestDetail.isPINSeq && !isPINMismatch;

        guestDetail.showError = !guestDetail.enterPINValid || !guestDetail.enterConfirmPINValid;

        return !guestDetail.showError;
    }

    checkEmptyPIN(pinNumber): boolean {
        return !(pinNumber && pinNumber.length > 0);
    }

    checkNumericPIN(pinNumber): boolean {
        const numericReg = /[^0-9]/g;
        return pinNumber.length === 4 && !numericReg.test(pinNumber);
    }

    hasSameDigits(pin): boolean {
        return (pin[0] === pin[1] && pin[0] === pin[2] && pin[0] === pin[3]);
    }

    increaseDigit(digit) {
        return (++digit % 10).toString();
    }

    isPinSequential(pin): boolean {
        return (
            this.increaseDigit(pin[0]) === pin[1] &&
            this.increaseDigit(pin[1]) === pin[2] &&
            this.increaseDigit(pin[2]) === pin[3]
        );
    }

    decreaseDigit(digit) {
        digit--;
        if (digit < 0) {
            digit += 10;
        }
        return digit.toString();
    }

    isPinReverseSequential(pin) {
        return (
            this.decreaseDigit(pin[0]) === pin[1] &&
            this.decreaseDigit(pin[1]) === pin[2] &&
            this.decreaseDigit(pin[2]) === pin[3]
        );
    }

    checkSeqPIN(pinNumber): boolean {
        if (pinNumber.length !== 4) {
            return true;
        }
        if (this.hasSameDigits(pinNumber)) {
            return false;
        }

        if (this.isPinSequential(pinNumber)) {
            return false;
        }

        if (this.isPinReverseSequential(pinNumber)) {
            return false;
        }
        return true;
    }

    checkPINMismatch(guestDetail): boolean {
        return guestDetail.pinNumber.length === 4 && guestDetail.confirmPinNumber.length === 4 &&
            guestDetail.pinNumber !== guestDetail.confirmPinNumber;
    }
}
